import LayerUtil from '../util/Layer';

/**
 * Project specific code for SAUBER webmap "Pilotregionen"
 */
const ProjectApp = class SauberPilotRegionsMap {
  /**
   * Constructor
   *
   * @param {ol/Map} olMap The OL map we work on
   */
  constructor (olMap) {
    const me = this;
    me.map = olMap;

    // zoom to area of interest extent
    const aoiLayer = LayerUtil.getLayerByLid('aoi-layer', me.map);
    let zoomed = false;
    aoiLayer.getSource().on('addfeature', () => {
      LayerUtil.zoomToLayerExtent(aoiLayer, me.map);
      zoomed = true;
    });

    // fallback in case the event did not fire or we registered to late
    window.setTimeout(() => {
      if (!zoomed) {
        LayerUtil.zoomToLayerExtent(aoiLayer, me.map);
      }
    }, 500);
  };
}

export default ProjectApp;



// WEBPACK FOOTER //
// ./src/sauber-pilots/SauberPilotRegionsMap.js